import React from 'react';
import { CheckCircle2, Clock, Award } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 75;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden pt-20">
      {/* Red vertical line on left edge */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#CC0000]"></div>

      {/* Diagonal grid pattern background */}
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `repeating-linear-gradient(
            45deg,
            #CC0000,
            #CC0000 2px,
            transparent 2px,
            transparent 40px
          ), repeating-linear-gradient(
            -45deg,
            #CC0000,
            #CC0000 2px,
            transparent 2px,
            transparent 40px
          )`
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="relative">
          {/* Logo positioned behind text - expanded with gradient fade */}
          <div className="absolute -top-20 -right-32 lg:-right-20 opacity-40 pointer-events-none">
            <div className="relative">
              <img 
                src="https://customer-assets.emergentagent.com/job_d291dd59-8a4e-4bc2-8d83-f1d842f45409/artifacts/3igxs2tz_Gemini_Generated_Image_6jshqc6jshqc6jsh.png"
                alt="Raider Washing Logo Background"
                className="w-[600px] md:w-[800px] lg:w-[900px] h-auto object-contain"
                style={{
                  clipPath: 'inset(0 8% 0 8%)'
                }}
              />
              {/* Gradient fade overlay */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-transparent to-transparent"></div>
              <div className="absolute inset-0 bg-gradient-to-l from-[#0a0a0a] via-transparent to-transparent"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-transparent to-transparent"></div>
            </div>
          </div>

          {/* Content */}
          <div className="relative z-10 max-w-4xl">
            <div className="space-y-8">
              <h1 className="font-['Bebas_Neue'] text-7xl md:text-8xl lg:text-9xl leading-none tracking-tight">
                <div className="text-white">CRYSTAL</div>
                <div className="text-white">CLEAR</div>
                <div><span className="shimmer-word">RESULTS.</span></div>
              </h1>

              <p className="text-gray-300 text-lg md:text-xl max-w-xl leading-relaxed">
                Professional window cleaning for homes in Lubbock and West Texas. 
                Founded and owned by Texas Tech University students who understand 
                what it takes to battle the dust and grime of our region.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={() => scrollToSection('quote')}
                  className="bg-[#CC0000] text-white px-8 py-4 rounded text-lg font-semibold hover:bg-[#B30000] transition-all duration-300 shadow-lg hover:shadow-red-900/50 hover:scale-105"
                >
                  Get a Free Quote
                </button>
                <button 
                  onClick={() => scrollToSection('results')}
                  className="border-2 border-[#CC0000] text-white px-8 py-4 rounded text-lg font-semibold hover:bg-[#CC0000]/10 transition-all duration-300"
                >
                  See the Results
                </button>
              </div>

              {/* Stats Bar */}
              <div className="grid sm:grid-cols-3 gap-6 pt-8 border-t border-[#CC0000]/30 max-w-2xl">
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="text-[#CC0000] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <div className="font-semibold text-white">100% Satisfaction</div>
                    <div className="text-gray-400 text-sm">Guarantee</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Clock className="text-[#CC0000] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <div className="font-semibold text-white">24HR Quote</div>
                    <div className="text-gray-400 text-sm">Response</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Award className="text-[#CC0000] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <div className="font-semibold text-white">TTU Student</div>
                    <div className="text-gray-400 text-sm">Owned & Operated</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
